import React from 'react';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import { FPActionButton, When } from 'UI/components/atoms';
import { SvgAdd } from 'UI/res';
import { getOrdinalSuffix } from 'UI/utils';

import { useBulkDrawerAttemptsHandlers } from '../../hooks/useBulkDrawerAttemptsHandlers';
import { useGetTriggerDays } from '../../hooks/useGetTriggerDays';
import { BulkEmailSectionsCollapser } from '../BulkEmailSectionsCollapser';

import { BulkAttemptForm } from './BulkAttemptForm';
import { ATTEMPT_ORDINAL_START, MAX_SEQUENCES_ATTEMPTS } from './BulkEmailDrawerAttempts.constants';
import { useSequencesAttemptsFormStyles } from './BulkEmailDrawerAttempts.styled';

const { sequences: sequencesCopies } = strings.bulkEmails.forms;

export const BulkEmailDrawerAttempts = () => {
  const classes = useSequencesAttemptsFormStyles();
  const {
    attemptsIds,
    attemptsLength,
    handleAddAttempt,
    handleRemoveAttempt,
    shouldDisableAddAttemptButton
  } = useBulkDrawerAttemptsHandlers();

  const { triggerDaysByType } = useGetTriggerDays();

  const addButtonAttemptText = getOrdinalSuffix(ATTEMPT_ORDINAL_START + attemptsLength);

  return (
    <>
      {attemptsIds.map((attemptId, index) => {
        const currentStep = ATTEMPT_ORDINAL_START + index;
        const shouldShowRemoveButton = attemptsLength > 1 || index !== 0;
        const isLastElement = attemptsLength - 1 === index;
        const ordinalSuffix = getOrdinalSuffix(currentStep);

        return (
          <BulkEmailSectionsCollapser
            key={attemptId}
            title={strings.formatString(sequencesCopies.sections.title, {
              attempt: ordinalSuffix
            })}
            shouldShowCollapseButton
            shouldShowBottomDivider={isLastElement}
            shouldShowTopDivider
          >
            <BulkAttemptForm
              attemptId={attemptId}
              recommendedTriggerDay={triggerDaysByType ? triggerDaysByType[ordinalSuffix] : null}
              step={currentStep}
            />
            <When condition={shouldShowRemoveButton}>
              <FPActionButton
                onClick={handleRemoveAttempt(attemptId)}
                text={sequencesCopies.buttons.removeStep}
                variant="text"
              />
            </When>
          </BulkEmailSectionsCollapser>
        );
      })}
      <Grid container className={classes.buttonsContainer}>
        <When condition={attemptsLength !== MAX_SEQUENCES_ATTEMPTS}>
          <FPActionButton
            disabled={shouldDisableAddAttemptButton}
            icon={SvgAdd}
            iconPosition="left"
            iconProps={{ size: 'sm' }}
            onClick={handleAddAttempt}
            text={strings.formatString(sequencesCopies.buttons.addStep, {
              attempt: addButtonAttemptText
            })}
            variant="outlined"
          />
        </When>
      </Grid>
    </>
  );
};
